import { useNodeId } from '@xyflow/react'
import { Undo2 } from 'lucide-react'
import { useNodeCentering } from '@/entities/node/lib/useNodeCentering'

export function RestoreViewportToolbar() {
  const nodeId = useNodeId()
  const { centeredNodeId, restorePreviousViewport } = useNodeCentering()
  const isCentered = !!nodeId && centeredNodeId === nodeId

  if (!isCentered) return null

  return (
    <div className="absolute left-2 top-2 z-10 pointer-events-auto">
      <button
        type="button"
        onClick={() => restorePreviousViewport()}
        className="flex items-center gap-1.5 rounded-full bg-black/16 px-3 py-1.5 text-xs text-white/60 backdrop-blur-[1px] transition hover:bg-black/28 hover:text-white/90"
      >
        <Undo2 className="h-3.5 w-3.5" />
        <span></span>
      </button>
    </div>
  )
}
